/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProductManualAliases {
  AUTOCOMPLETE_APPLICATION = 'autocomplete-application',
  AUTOCOMPLETE_MODULE = 'autocomplete-module',
  CONTEXTUAL_BAR_CONTENT = 'contextual-bar-content',
  DATA_TABLE_EXTERNAL = 'data-table-external',
  FETCH_APPLICATION = 'fetch-application',
  FETCH_EXTERNAL = 'fetch-external',
  FETCH_MODULE = 'fetch-module',
  FIELD_APPLICATION = 'field-application',
  FIELD_FILE_NAME = 'field-file-name',
  FIELD_MODULE = 'field-module',
  FILTER_LIST = 'filter-list',
  FILTERED_LIST_0 = 'filtered-list-0',
  INPUT_FILE_NAME = 'input-file-name',
  LAYOUT_PRODUCT_MANUAL = 'layout-product-manual',
  MAPPER_APPLICATION = 'mapper-application',
  MAPPER_MODULE = 'mapper-module',
  PAGINATOR_1 = 'paginator-1',
  PANEL_CONTENT = 'panel-content',
  TABLE_COLUMN_ACTION = 'table-column-action',
  TABLE_COLUMN_APPLICATION = 'table-column-application',
  TABLE_COLUMN_MODIFIED_AT = 'table-column-modified-at',
  TABLE_COLUMN_MODULE = 'table-column-module',
  TABLE_COLUMN_NAME = 'table-column-name',
  TEXT_APPLICATION = 'text-application',
  TEXT_MODULE = 'text-module',
}
export { ProductManualAliases };
